export interface HardwareError {
    serialNumber: string;
    errorCode: string;
    errorDate: string;
    errorCategory: string | null;
    errorDescription: string | null;
    troubleshootingInfo: string | null;
    severity: string | null;
    productSystem: string | null;
    machineProduct: string | null;
    errorSource: string | null;
    errorSourceDescription: string | null;
}

export interface HardwareErrorsResponse {
    errors: HardwareError[];
    totalCount: number;
    page: number;
    pageSize: number;
}


export interface ErrorTimelinePoint {
    date: string;
    count: number;
    source: string;
    errorCodes: Array<{ code: string; count: number }>;
}

export const severityOptions: string[] = ['HIGH', 'MEDIUM', 'LOW', 'OPERATOR ACTIONS', 'SYSTEM AUTOCONTROL'];

export const severityColorMap: Record<string, string> = {
    'HIGH': '#d32f2f',              // Red
    'MEDIUM': '#f57c00',            // Orange
    'LOW': '#1976d2',               // Blue
    'OPERATOR ACTIONS': '#9e9e9e',  // Light gray
    'SYSTEM AUTOCONTROL': '#424242' // Dark gray
};





